import React from "react";

const profileImage = `${process.env.PUBLIC_URL}/haseeb.png`;

const ProfilePortrait = ({ className = "salva-home-image dark-salva-home-image" }) =>
{
    return (
      <div className={className}>
        <img
          src={profileImage}
          alt="Haseeb Sajjad"
          className="salva-profile-img"
        />
      </div>
    );
};

export default ProfilePortrait;
